import { Component, OnInit, ViewEncapsulation, } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Auth } from '../../autentication/Auth';

@Component({
	selector: 'app-terms-of-use',
	templateUrl: './terms-of-use.component.html',
	styleUrls: ['./terms-of-use.component.styl'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger(
			'enterAnimation', [
				transition(':enter', [
					style({opacity: 0}),
					animate('500ms', style({opacity: 1}))
				]),
				transition(':leave', [
					style({opacity: 1}),
					animate('0ms', style({opacity: 0}))
				])
			]
		)
	],
})

export class TermsOfUseComponent {
	showTerms: boolean = false;
	showPac: boolean = false;

	clickTerms() {
		let urlTermos;

		if (Auth.getInstance().getUser().personType === 'F') {
			urlTermos = 'assets/pdf/Termos_e_Condicoes_Conta_de_Depositos_PF.pdf';
		} else {
			urlTermos = 'assets/pdf/Termos_e_Condicoes_Conta_de_Depositos_PJ.pdf';
		}


		window.open(urlTermos, '_blank').focus();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/terms-of-use/terms-of-use.component.ts